import React from 'react';
import './_Textarea.scss';

Textarea.defaultProps = {
    rows: 3,
    maxlength: 500,
    disabled: false,
};

function Textarea(props) {
    const mod_class = ['Textarea'].join(' ');

    return (
        <textarea
            className={mod_class}
            name={props.name}
            rows={props.rows}
            cols="80"
            placeholder={props.placeholder}
            onChange={props.onChange}
            maxLength={props.maxlength}
            disabled={props.disabled}
            value={props.value}
        ></textarea>
    );
}

export default Textarea;
